import { getNextOrder } from '../useSortableOrder'

describe('getNextOrder', () => {
  it('moves an item to a later one-based position', () => {
    expect(getNextOrder([1, 2, 3], 1, 3)).toEqual({
      movedId: 1,
      nextOrder: [2, 3, 1],
      targetIndex: 2,
      targetPosition: 3,
    })
  })

  it('moves an item to an earlier position', () => {
    expect(getNextOrder([1, 2, 3], 3, 1)).toEqual({
      movedId: 3,
      nextOrder: [3, 1, 2],
      targetIndex: 0,
      targetPosition: 1,
    })
  })

  it('matches numeric and string drag IDs', () => {
    expect(getNextOrder([1, 2, 3], '3', '1')).toEqual({
      movedId: 3,
      nextOrder: [3, 1, 2],
      targetIndex: 0,
      targetPosition: 1,
    })
  })

  it('ignores drops on the same item or outside the ordered IDs', () => {
    expect(getNextOrder([1, 2, 3], 1, 1)).toBeNull()
    expect(getNextOrder([1, 2, 3], 1, 4)).toBeNull()
  })
})
